import { VehicleSize } from '@cobliteam/common-types';

/** Same ceiling the VehicleDrawer slider uses. */
export const MAX_SPEED_LIMIT = 150;

/**
 * Suggested default allowed speed per porte (km/h) — lighter vehicles get a higher default.
 * Intentionally different from `apiSizeToSuggestedSpeedKmh` (libs/ui-business/utils/vehicleSize.ts,
 * the VehicleDrawer rule: 110/110/90) — the guide's defaults come from its own spec.
 */
export const DEFAULT_KMH: Record<VehicleSize, number> = {
  [VehicleSize.SMALL]: 110,
  [VehicleSize.MEDIUM]: 90,
  [VehicleSize.BIG]: 80,
};

/** Stable porte order shown in the forms. */
export const PORTE_ORDER: VehicleSize[] = [VehicleSize.SMALL, VehicleSize.MEDIUM, VehicleSize.BIG];
